var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about_address mt_7 pt_6"},[_c('title-box',{attrs:{"text":"联系我们"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address content_box d_flex"},[_c('div',{staticClass:"qr_box d_flex justify_content_center w_100"},[_c('div',{staticClass:"qr_item d_flex flex_column align_items_center"},[_c('img',{attrs:{"src":require("@/assets/about-us/qrcode.png"),"alt":"二维码"}})])])])
}]

export { render, staticRenderFns }